import React from "react";
import { Link, useLocation } from "react-router-dom";
import "../BinTransfer/BinTransferMain.css";
import { ArrowForwardIos } from "@mui/icons-material";
function Delivery_BreadCrumbs() {
  const location = useLocation();
  const vPathName = location.pathname;
  return (
    <div className="container-fluid ">
      {vPathName === "/deliverySummary" ? (
        <div>
          <span
            className="breadcrumb-not-active "
            //  style={{ fontSize: '1rem', textDecorationLine: 'underline' }}
          >
            Delivery Summary{" "}
          </span>
        </div>
      ) : vPathName === "/deliveryDetail" ? (
        <div className="d-flex align-items-center">
          <Link
            to="/deliverySummary"
            state={location}
            // style={{ fontSize: '1rem', marginRight: '1rem' }}
            className={"breadcrumb-active mr-2"}
          >
            Summary
          </Link>
          <ArrowForwardIos color="info" style={{ marginRight: "1rem" }} />
          <div>
            <span
              className="breadcrumb-not-active"
              //  style={{ fontSize: '0.85rem', textDecorationLine: 'underline' }}
            >
              Delivery Detail{" "}
            </span>
          </div>
        </div>
      ) : vPathName === "/deliveryItemDetail" ? (
        <div className="d-flex align-items-center">
          <Link
            to="/deliverySummary"
            state={location}
            // style={{ fontSize: '1rem', marginRight: '1rem' }}
            className={"breadcrumb-active mr-2"}
          >
           Summary
          </Link>
          <ArrowForwardIos color="info" style={{ marginRight: "1rem" }} />
          <Link
            to="/deliveryDetail"
            state={location}
            // style={{ fontSize: '1rem', marginRight: '1rem' }}
            className={"breadcrumb-active mr-2"}
          >
              Detail
          </Link>
          <ArrowForwardIos color="info" style={{ marginRight: "1rem" }} />
          <div>
            <span
              className="breadcrumb-not-active"
              //  style={{ fontSize: '0.85rem', textDecorationLine: 'underline' }}
            >
              View{" "}
            </span>
          </div>
        </div>
      ) :  (
        <></>
      )}
    </div>
  );
}
export default Delivery_BreadCrumbs;
